import React, { useEffect, useState } from 'react';
import AccordionBase from '../components/3modules/faq/AccordionBase';
import List from '../components/3modules/faq/List';
import Header from '../components/3modules/faq/Header';
import Search from '../components/3modules/faq/Search';
import TempImage from '../assets/two-application-screens.png';
import LoaderBackdrop from '../components/2compounds/LoaderBackdrop';
import '../components/3modules/faq/styles.scss';

const Faq = () => {
  const [id, setId] = useState('');
  const [term, setTerm] = useState('');
  const [loaded, setLoaded] = useState(false);
  const [openAccordion, setOpenAccordion] = useState(true);

  const handleId = (event, linkId) => {
    event.preventDefault();
    setId(linkId);
    setOpenAccordion(true);

    document.getElementById(`accordion${linkId}`).scrollIntoView();
  };

  useEffect(() => {
    const loadingTimer = setTimeout(() => {
      setLoaded(true);
    }, 500);

    return () => clearTimeout(loadingTimer);
  }, []);

  return loaded ? (
    <div className="faq-page">
      <Header />
      <div className="faq-page__container">
        <div id="structure-section">
          <h2 className="faq-page__section-title">
            Structure &amp; Navigation
          </h2>
          <picture className="image-sturcture">
            <source
              type="image/webp"
              srcSet="https://sixfactor.com/assets/map-structure-proximity.webp"
              width="100%"
            />
            <img
              alt="Application Structure"
              src="https://sixfactor.com/assets/map-structure-proximity.png"
              width="100%"
            />
          </picture>
        </div>
        <br />
        <hr />
      </div>

      <div className="faq-page__user-guide-section" id="user-guide-section">
        <h2 className="faq-page__section-title">User Guides</h2>

        <div className="faq-page__user-guide">
          <div className="faq-page__guide-pdf">
            {/* TODO Switch the image with PDF file once Carol creates it */}
            {/* <h3 className="faq-page__guide-title">Reference Guide</h3> */}
            {/* <iframe src="//.pdf" width="100%" height="900px"></iframe> */}
            <img alt="Proximity user guide" src={TempImage} width="90%" />
          </div>
          <div className="faq-page__guide">
            <h3 className="faq-page__guide-title">Quick Guide</h3>
            <List handleId={handleId} />
          </div>
        </div>
      </div>

      <div className="faq-page__container faq-page__faq-container">
        <hr />
        <div className="faq-page__faq-section" id="faq-section">
          <h2 className="faq-page__section-title">FAQ Best Practice</h2>
          <p style={{ textAlign: 'center' }}>
            The FAQ is reviewed and updated periodically compiling feedback,
            queries, comments, etc. from various stakeholders. As and when
            Proximity is enhanced, the FAQ will be updated prior to product
            release.
          </p>
          <Search term={term} setTerm={setTerm} />

          <AccordionBase
            id={id}
            term={term}
            setOpenAccordion={setOpenAccordion}
            openAccordion={openAccordion}
          />
        </div>
      </div>
    </div>
  ) : (
    <LoaderBackdrop open />
  );
};

export default Faq;
